export default class UserQuery {

    public static CreateUser = `mutation CreateUserQuery($input: UserInput) {
        createUser(input: $input) {
            id
        }
    }`;

    public static GetUser = `query GetUserQuery($id: ID) {
        getUser(id:$id) {
            id
            email
            name
            plan
            subscriptionId
            isAdmin
        }
    }`;
}